// Rule-set registry. Rule packs are bundled JSON files keyed by
// "{locale}/{version}". Adding a new country = drop a JSON file in
// app/frontend/rules/<locale>/<version>.json and register it here.
//
// Vite statically analyses these imports, so the JSON is part of the
// editor bundle and available synchronously (no fetch on page load).

import ru2024_01 from "../rules/ru/2024-01.json"

const PACKS = {
  "ru/2024-01": ru2024_01,
}

export const DEFAULT_LOCALE = "ru"
export const DEFAULT_VERSION = "2024-01"

export function loadRuleSet(locale = DEFAULT_LOCALE, version = DEFAULT_VERSION) {
  const key = `${locale}/${version}`
  if (PACKS[key]) return PACKS[key]
  // Unknown pack — this would silently serve RU norms to a non-RU plot
  // once we ship additional locales. Log it so the misconfiguration is
  // at least visible in dev.
  if (typeof console !== "undefined") {
    console.warn(`[plot-planner] Unknown rule-set "${key}", falling back to ${DEFAULT_LOCALE}/${DEFAULT_VERSION}`)
  }
  return PACKS[`${DEFAULT_LOCALE}/${DEFAULT_VERSION}`]
}

export function availableRuleSets() {
  return Object.entries(PACKS).map(([key, pack]) => ({
    key, locale: pack.locale, version: pack.version, title: pack.title,
  }))
}
